<template>
    <client-page>
        <v-container>
            <div class="tit-wrap text-center">
                <h2 class="tit tit--lg">작품문의</h2>
            </div>

            <form-input code="private-sale" skin="private-sale"></form-input>
        </v-container>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import FormInput from "@/components/client/form/form-input.vue";

export default {
    components: {
        ClientPage,
        FormInput,
    },
    mounted() {
        if (!this.$store.state.payload?._user) {
            alert("작품문의는 회원가입이 필요한 기능입니다");
            this.$router.replace("/login");
        }
    },
};
</script>
